/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Limit_3_ValueInputs */

const en_svc_integration_limit_3_value = /** @type {(inputs: Svc_Integration_Limit_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The design lets the model provider change later.`)
};

const lv_svc_integration_limit_3_value = /** @type {(inputs: Svc_Integration_Limit_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risinājums ļauj vēlāk nomainīt modeļa piegādātāju.`)
};

/**
* | output |
* | --- |
* | "The design lets the model provider change later." |
*
* @param {Svc_Integration_Limit_3_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_limit_3_value = /** @type {((inputs?: Svc_Integration_Limit_3_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Limit_3_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_limit_3_value(inputs)
	return en_svc_integration_limit_3_value(inputs)
});